import { z } from 'zod'
import { createdAtSortQueryShape, creatorListQueryShape } from '../list-query/contract.ts'
import { accountDisplaySchema } from '../profile/contract.ts'

const id = z.number().int().positive()
export const expenseDateSchema = z.iso.date({ error: '请填写有效日期（YYYY-MM-DD）' })
export const expenseAmountSchema = z
  .string()
  .trim()
  .regex(/^\d{1,16}(\.\d{1,2})?$/, '金额须为非负数，最多两位小数')
export const expenseDataSchema = z.object({
  organizationId: id,
  payeeId: id,
  expenseBusinessId: id,
  dueAt: expenseDateSchema,
  amount: expenseAmountSchema,
  note: z.string().trim().max(5000).nullish()
})
export const expenseSaveSchema = z
  .object({
    id: id.optional(),
    version: id.optional(),
    writeKey: z.uuid(),
    data: expenseDataSchema
  })
  .refine((v) => !v.id || !!v.version, { message: '请刷新记录后重试', path: ['version'] })
export const expenseListSchema = z.object({
  current: id.default(1),
  pageSize: id.max(100).default(20),
  id: id.optional(),
  keyword: z.string().trim().max(255).optional(),
  organizationId: id.optional(),
  payeeId: id.optional(),
  expenseBusinessId: id.optional(),
  dueFrom: expenseDateSchema.optional(),
  dueTo: expenseDateSchema.optional(),
  ...creatorListQueryShape,
  ...createdAtSortQueryShape
})
export const expenseRowSchema = expenseDataSchema.extend({
  id,
  version: id,
  note: z.string().nullable(),
  organizationName: z.string(),
  payeeName: z.string(),
  businessName: z.string(),
  businessColor: z.string(),
  createdAt: z.date(),
  creator: accountDisplaySchema
})
export const expenseRemoveSchema = z.object({
  records: z
    .array(z.object({ id, version: id }))
    .min(1)
    .max(100)
})
export const expenseImportRowSchema = z.object({
  organization: z.string().trim().max(255),
  payee: z.string().trim().max(255),
  business: z.string().trim().max(255),
  dueAt: z.string().max(100),
  amount: z.string().max(100),
  note: z.string().max(5000).optional()
})
export const expenseImportSchema = z.object({
  rows: z.array(expenseImportRowSchema).min(1).max(500),
  writeKey: z.uuid()
})
export const expenseImportResultSchema = z.object({
  count: z.number(),
  errors: z.array(z.object({ row: z.number(), message: z.string() }))
})
export type ExpenseData = z.infer<typeof expenseDataSchema>
export type ExpenseRow = z.infer<typeof expenseRowSchema>
export type ExpenseListInput = z.infer<typeof expenseListSchema>
export type ExpenseImportRow = z.infer<typeof expenseImportRowSchema>
export type ExpenseImportInput = z.infer<typeof expenseImportSchema>
